export default __webpack_public_path__ + "static/grace-ling@2x-375c9a4df2ec33172f4ab2d873009a77.png";